"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STREAM_STATUS_CHANGED = exports.STREAM_STATUS_CHANGE = exports.STREAM_ROOM_PREFIX = exports.SCREEN_SHARE_STOP = void 0;
var SCREEN_SHARE_STOP = exports.SCREEN_SHARE_STOP = 'screenShareStop';
var STREAM_STATUS_CHANGE = exports.STREAM_STATUS_CHANGE = 'streamStatusChange';
var STREAM_STATUS_CHANGED = exports.STREAM_STATUS_CHANGED = 'streamStatusChanged';
var STREAM_ROOM_PREFIX = exports.STREAM_ROOM_PREFIX = 'streamChannel';